/* @flow */
export default Object.freeze({
  GREEN: '#52C41A',
  BLUE: '#1990FF',
  ORANGE: '#FFA400',
});
